import { render, staticRenderFns } from "./CustomInvoices.vue?vue&type=template&id=058cdf4c&"
import script from "./CustomInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports